import { NgFor, NgIf, CommonModule, NgForOf } from '@angular/common';
import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { StatisticsService } from '../../services/statistics.service';
import { LineComponent } from "../../charts/line/line.component";
import { QuestionService } from '../../services/question.service';
import { WhatsappBtnComponent } from '../../shared/components/whatsapp-btn/whatsapp-btn.component';
import { RouterLink } from '@angular/router';
@Component({
  selector: 'app-logged-index',
  standalone: true,
  imports: [CommonModule, NgFor, NgIf, NgForOf, LineComponent, WhatsappBtnComponent, RouterLink],
  templateUrl: './logged-index.component.html',
  styleUrl: './logged-index.component.scss'
})
export class LoggedIndexComponent {
  name: string | null = '';
  currentIndex: number = 0;
  totalAnswers: number = 0;
  totalRightAnswers: number = 0;
  totalWrongAnswers: number = 0;
  dates: string[] = [];
  correctsData: number[] = [];
  wrongsData: number[] = [];
  exams: any[] = [];
  isLoading: boolean = true;
  isLoading2: boolean = true;

  videos: { id: string }[] = [
    { id: 'RySjXJMbFZw?si=SXL1D2Llt5unrwKg' },
    { id: 'RySjXJMbFZw?si=SXL1D2Llt5unrwKg' },
    { id: 'RySjXJMbFZw?si=SXL1D2Llt5unrwKg' },
    { id: 'RySjXJMbFZw?si=SXL1D2Llt5unrwKg' },
    { id: 'RySjXJMbFZw?si=SXL1D2Llt5unrwKg' },
    { id: 'RySjXJMbFZw?si=SXL1D2Llt5unrwKg' },
    { id: 'RySjXJMbFZw?si=SXL1D2Llt5unrwKg' }
  ];

  constructor(
    private sanitizer: DomSanitizer,
    private statisticsService: StatisticsService,
    private questionService: QuestionService
  ) { }

  ngOnInit() {
    this.name = localStorage.getItem('name');
    this.userStatistics();
    this.loadExams();
  }
  getVideoUrl(video: { id: string }): SafeResourceUrl {
    const videoUrl = `https://www.youtube.com/embed/${video.id}`;
    return this.sanitizer.bypassSecurityTrustResourceUrl(videoUrl);
  }
  get carouselTransform() {
    const itemWidth = 580;
    return `translateX(-${this.currentIndex * itemWidth}px)`;
  }

  nextVideo() {
    // Avançar para o próximo vídeo
    this.currentIndex = (this.currentIndex + 1) % this.videos.length;
  }

  prevVideo() {
    // Voltar para o vídeo anterior
    this.currentIndex = (this.currentIndex - 1 + this.videos.length) % this.videos.length;
  }

  userStatistics() {
    this.statisticsService.userStatistics().subscribe(
      (response) => {
        if (!response.performance || response.performance.length === 0) {
          // Dados mocados
          this.dates = ['Hoje'];
          this.correctsData = [0];
          this.wrongsData = [0];
          this.totalAnswers = 0;
          this.totalRightAnswers = 0;
          this.totalWrongAnswers = 0;
        } else {
          this.dates = response.performance.map((p) => new Date(p.day).toLocaleDateString());
          this.correctsData = response.performance.map((p) => p.correct);
          this.wrongsData = response.performance.map((p) => p.wrong);
          this.totalAnswers = response.total;
          this.totalRightAnswers = response.right;
          this.totalWrongAnswers = response.wrong;
        }
        this.isLoading2 = false;
      },
      (error) => {
        console.error('Erro ao carregar as estatísticas', error);
        // Em caso de erro, também usa dados mocados
        this.dates = ['Hoje'];
        this.correctsData = [0];
        this.wrongsData = [0];
        this.totalAnswers = 0;
        this.totalRightAnswers = 0;
        this.totalWrongAnswers = 0;
        this.isLoading2 = false;
      }
    );
  }

  loadExams() {
    this.questionService.getExams().subscribe(
      (data) => {
        this.exams = data[0];
        this.isLoading = false;
      },
      (error) => {
        console.error('Erro ao carregar os simulados:', error);
        this.isLoading = false;
      }
    );
  }
}